import React from 'react';
import { ControlPanel } from './ControlPanel';

function ControlPanelContainer(props) {
  const { options, setOptions } = props;

  const handleChange = (field, value) => {
    setOptions((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const rgbToHex = (rgbArray) =>
    `#${rgbArray.map((val) => val.toString(16).padStart(2, "0")).join("")}`;

  function hexToRgb(hex) {
    hex = hex.replace(/^#/, "");

    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;

    return [r, g, b];
  }

  return (
    <ControlPanel
      options={options}
      rgbToHex={rgbToHex}
      handleChange={handleChange}
      hexToRgb={hexToRgb}
    />
  );
}

export default ControlPanelContainer;
